import Alpine from "alpinejs";
import { subscribeBackInStock } from "../../_api/klaviyo";

export const alpineDataKlaviyoBackInStock = () =>
  Alpine.data("klaviyoBackInStock", () => ({
    email: "",
    companyId: KLAVIYO_COMPANY_ID,
    error: "",
    placeholder: "Email Address",
    loading: false,
    success: false,
    handleKeydown(event) {
      if (event.key === "Enter") {
        this.submit();
      }
    },
    checkIsValidEmail() {
      const emailInput = this.$refs.email;
      const isValid = emailInput.checkValidity();
      return isValid;
    },
    async submit(variantId) {
      this.error = "";
      this.loading = true;

      if (!this.checkIsValidEmail()) {
        this.email = "";
        this.error = "Invalid email address";
        this.loading = false;
        return;
      }

      if (!variantId) {
        this.email = "";
        this.error = "Variant ID is required";
        this.loading = false;
        return;
      }

      try {
        const response = await subscribeBackInStock({
          email: this.email,
          variantId,
          companyId: this.companyId,
        });

        this.loading = false;
        if (response.error) {
          this.email = "";
          this.error = response.error;
          this.success = false;
        } else {
          this.email = "";
          this.success = true;
          this.placeholder = "You're signed up!";
        }
      } catch (error) {
        this.email = "";
        this.error = error.message;
        this.loading = false;
        this.success = false;
      }
    },
  }));
